var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-modal", {
    staticClass: "box",
    attrs: {
      title: _vm.$t("资料审核"),
      visible: _vm.examineVisible,
      width: 1000,
      height: 1000
    },
    on: {
      cancel: _vm.handleCancel
    }
  }, [_c("a-form-model", {
    ref: "form",
    staticClass: "mt-20",
    attrs: {
      model: _vm.formData,
      rules: _vm.formRules
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("场景资料")
    }
  }, [_c("div", {
    staticClass: "media-grid"
  }, _vm._l(_vm.videoList, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "media-item"
    }, [item.type === "video" ? _c("video", {
      staticClass: "media-content",
      attrs: {
        controls: ""
      },
      on: {
        click: function ($event) {
          return _vm.preview(item, index);
        }
      }
    }, [_c("source", {
      attrs: {
        src: item.url,
        type: "video/mp4"
      }
    }), _vm._v(" " + _vm._s(_vm.$t("您的浏览器不支持video标签哦，请联系管理员")) + " ")]) : item.type === "image" ? _c("img", {
      staticClass: "media-content",
      attrs: {
        src: item.url
      },
      on: {
        click: function ($event) {
          return _vm.preview(item, index);
        }
      }
    }) : _vm._e()]);
  }), 0)]), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("状态"),
      prop: "status"
    }
  }, [_c("a-select", {
    attrs: {
      disabled: _vm.initStatus !== "pending",
      placeholder: "请选择状态"
    },
    on: {
      change: _vm.handleStatusChange
    },
    model: {
      value: _vm.formData.status,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "status", $$v);
      },
      expression: "formData.status"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "approved"
    }
  }, [_vm._v(_vm._s(_vm.$t("通过")))]), _c("a-select-option", {
    attrs: {
      value: "rejected"
    }
  }, [_vm._v(_vm._s(_vm.$t("拒绝")))])], 1)], 1), _vm.formData.status === "rejected" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("拒绝理由")
    }
  }, [_c("a-input", {
    attrs: {
      type: "textarea",
      rows: 4
    },
    model: {
      value: _vm.formData.rejectReason,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "rejectReason", $$v);
      },
      expression: "formData.rejectReason"
    }
  })], 1) : _vm._e()], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    attrs: {
      disabled: _vm.initStatus !== "pending"
    },
    on: {
      click: _vm.handleCancel
    }
  }, [_vm._v(_vm._s(_vm.$t("取消")))]), _c("a-button", {
    attrs: {
      disabled: _vm.initStatus !== "pending",
      type: "primary",
      loading: _vm.loading
    },
    on: {
      click: _vm.handleConfirm
    }
  }, [_vm._v(_vm._s(_vm.$t("确认")))])], 1)], 2), _c("preview-modal", {
    attrs: {
      visible: _vm.previewVisible,
      videoTypeList: ["mp4"],
      fileList: _vm.videoList,
      show: _vm.fileType,
      src: _vm.previewSrc,
      currentIndex: _vm.currentPreviewIndex
    },
    on: {
      cancel: _vm.cancelPre
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };